module.exports = __webpack_public_path__ + "img/cov-aboutus.7d875991.jpg";